import { render, staticRenderFns } from "./SumarizacaoPagamentos.vue?vue&type=template&id=01a8532a"
import script from "./SumarizacaoPagamentos.vue?vue&type=script&lang=js"
export * from "./SumarizacaoPagamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports